import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";

// Components
import UserRoute            from "dashboard/dist/Components/UserRoute";



/**
 * Only Authenticated Admins can access the given Component
 */
class AdminRoute extends React.Component {
    /**
     * Do the Render
     * @returns {Object}
     */
    render() {
        const { isAuthenticated, isAdmin, ...rest } = this.props;

        return <UserRoute
            {...rest}
            isAuthenticated={isAuthenticated}
            isValid={isAdmin}
        />;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        isAuthenticated : PropTypes.bool.isRequired,
        isAdmin         : PropTypes.bool.isRequired,
        isHidden        : PropTypes.bool,
        url             : PropTypes.string.isRequired,
        component       : PropTypes.oneOfType([ PropTypes.func, PropTypes.object ]).isRequired,
        exact           : PropTypes.bool,
        type            : PropTypes.string,
        path            : PropTypes.string,
        location        : PropTypes.object,
        match           : PropTypes.object,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            isAuthenticated : state.auth.isAuthenticated,
            isAdmin         : state.auth.isAdmin,
        };
    }
}

export default connect(AdminRoute.mapStateToProps)(AdminRoute);
